import React from "react";
import Gallery from "./Slider";
import { Link } from "react-router";

export default function Home() {
  return (
    <section id="home" className="hero-wrapper">
      <div className="container pt-4 pb-5">
        {/* Welcome Eyebrow & Hero Header */}
        <div className="text-center mx-auto mb-4" style={{ maxWidth: "860px" }}>
          <div className="eyebrow-badge">
            <i className="fas fa-cross"></i>
            <span>Roman Catholic Archdiocese of Madurai</span>
          </div>
          <h1
            style={{
              fontFamily: "'Playfair Display', Georgia, serif",
              fontSize: "clamp(2.1rem, 4vw, 3.25rem)",
              color: "var(--cathedral-navy)",
              fontWeight: 700,
              lineHeight: 1.2,
              marginBottom: "16px"
            }}
          >
            Welcome to St. Mary's Cathedral
          </h1>
          <div className="cross-ornament">
            <i className="fas fa-cross"></i>
          </div>
          <p
            style={{
              fontSize: "1.1rem",
              color: "var(--cathedral-text-secondary)",
              lineHeight: 1.7,
              marginBottom: "24px"
            }}
          >
            Built in 1841 and standing proudly in the historic city of Madurai, St. Mary's Cathedral is the seat of the Archdiocese of Madurai — welcoming all to worship, pray, and grow in Christian fellowship.
          </p>

          {/* Meaningful Quick CTAs */}
          <div className="d-flex flex-wrap justify-content-center gap-3 mb-4">
            <a href="#masstimings" className="btn-cathedral-primary">
              <i className="fas fa-clock me-2"></i> Mass Timings
            </a>
            <a href="#history" className="btn-cathedral-outline">
              <i className="fas fa-landmark me-2"></i> Cathedral History
            </a>
            <Link to="/photo-gallery" className="btn-cathedral-gold">
              <i className="fas fa-images me-2"></i> Photo Gallery
            </Link>
          </div>
        </div>

        {/* Hero Cathedral Imagery Showcase */}
        <div className="row justify-content-center">
          <div className="col-12">
            <Gallery />
          </div>
        </div>

        {/* Liturgical Quick Bar */}
        <div className="mt-4 p-3 p-md-4 rounded-3" style={{ background: "#ffffff", border: "1px solid #eae4d8", boxShadow: "0 4px 18px rgba(27, 58, 107, 0.05)" }}>
          <div className="row g-3 text-center align-items-center">
            <div className="col-md-3 border-end-md">
              <div className="d-flex align-items-center justify-content-center gap-2">
                <i className="fas fa-calendar-alt text-secondary" style={{ fontSize: "1.2rem" }}></i>
                <div className="text-start">
                  <span className="d-block text-muted text-uppercase" style={{ fontSize: "0.72rem", letterSpacing: "1px", fontWeight: 700 }}>Sunday Masses</span>
                  <strong style={{ color: "var(--cathedral-navy)", fontSize: "0.92rem" }}>6:00 AM, 7:00 AM, 6:00 PM</strong>
                </div>
              </div>
            </div>
            <div className="col-md-3 border-end-md">
              <div className="d-flex align-items-center justify-content-center gap-2">
                <i className="fas fa-sun text-secondary" style={{ fontSize: "1.2rem" }}></i>
                <div className="text-start">
                  <span className="d-block text-muted text-uppercase" style={{ fontSize: "0.72rem", letterSpacing: "1px", fontWeight: 700 }}>Daily Masses</span>
                  <strong style={{ color: "var(--cathedral-navy)", fontSize: "0.92rem" }}>Morning 6:00 AM & Eve 6:00 PM</strong>
                </div>
              </div>
            </div>
            <div className="col-md-3 border-end-md">
              <div className="d-flex align-items-center justify-content-center gap-2">
                <i className="fas fa-pray text-secondary" style={{ fontSize: "1.2rem" }}></i>
                <div className="text-start">
                  <span className="d-block text-muted text-uppercase" style={{ fontSize: "0.72rem", letterSpacing: "1px", fontWeight: 700 }}>Weekly Novenas</span>
                  <strong style={{ color: "var(--cathedral-navy)", fontSize: "0.92rem" }}>Tue: St. Antony | Fri: Sacred Heart</strong>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="d-flex align-items-center justify-content-center gap-2">
                <i className="fas fa-map-marker-alt text-secondary" style={{ fontSize: "1.2rem" }}></i>
                <div className="text-start">
                  <span className="d-block text-muted text-uppercase" style={{ fontSize: "0.72rem", letterSpacing: "1px", fontWeight: 700 }}>Cathedral Location</span>
                  <strong style={{ color: "var(--cathedral-navy)", fontSize: "0.92rem" }}>E Veli St, Madurai, TN</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
